import { urlBase } from "./config";
import axiosInstance from "../services/config/axiosinstance";

async function createConfigApp(data, jwt, typeRequest, idConfig) {
  var url = "";
  if (idConfig) {
    url = `${urlBase}/mobileappconfig/${idConfig}`;
  } else {
    url = `${urlBase}/mobileappconfig`;
  }

  try {
    const config = {
      method: typeRequest,
      url: url,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    };
    const response = await axiosInstance(config);
    return response;
  } catch (error) {
    // console.log(error.response);
    return error.response;
  }
}

async function getConfigApp(idEvent, jwt) {
  try {
    const config = {
      method: "get",
      url: `${urlBase}/mobileappconfig/${idEvent}/event`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const response = await axiosInstance(config);
    return response;
  } catch (error) {
    // console.log(error.response);
    return error.response;
  }
}

export { createConfigApp, getConfigApp };
